'use strict';

module.exports = Object.freeze([
  'shared_personal_data',
  'personal_data',
  'consents',
  'communication_channels',
]);
